var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatDiaryNewBreedingDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0072b2;}.cls-2{fill:#64c0ff;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heat_cycle_new_mating"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 300,
    r: 299.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M351.59,85.12H279.38a21.76,21.76,0,0,0,0,43.52h18.14L270.9,155.26a111.19,111.19,0,1,0-85.73,200v21.15H171.38a21.76,21.76,0,1,0,0,43.52h13.79v6a21.76,21.76,0,1,0,43.51,0v-6h14.91a21.76,21.76,0,0,0,0-43.52H228.68V355.24a111.16,111.16,0,0,0,72.23-168.45l28.92-28.93v21.23a21.76,21.76,0,0,0,43.52,0V106.88A21.76,21.76,0,0,0,351.59,85.12ZM206.93,313.87a67.7,67.7,0,1,1,67.69-67.69A67.77,67.77,0,0,1,206.93,313.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M370,523.52a58.33,58.33,0,0,1-58.26-58.26V418.1H263.34a56.8,56.8,0,1,1,0-113.59H311.7V257.42a58.26,58.26,0,0,1,116.52,0v47.09h56.16a56.8,56.8,0,1,1,0,113.59H428.22v47.16A58.33,58.33,0,0,1,370,523.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370,214.16a43.39,43.39,0,0,1,43.26,43.26v62.09h71.16a41.8,41.8,0,1,1,0,83.59H413.22v62.16A43.39,43.39,0,0,1,370,508.52h0a43.39,43.39,0,0,1-43.26-43.26V403.1H263.34a41.8,41.8,0,1,1,0-83.59H326.7V257.42A43.39,43.39,0,0,1,370,214.16h0m0-30a73.35,73.35,0,0,0-73.26,73.26v32.09H263.34a71.8,71.8,0,1,0,0,143.59H296.7v32.16a73.26,73.26,0,0,0,146.52,0V433.1h41.16a71.8,71.8,0,1,0,0-143.59H443.22V257.42A73.34,73.34,0,0,0,370,184.16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatDiaryNewBreedingDate);
export default __webpack_public_path__ + "static/media/heat_diary_new_breeding_date.a52a497ef22257a7ce1080025cc3c1da.svg";
export { ForwardRef as ReactComponent };